import React, { useState } from "react";

interface FeeItem {
    feeTitle: string;
    due: number;
    amount: number;
    exceedError?: boolean;
    invalidError?: boolean;
}

type Props = {
    fees: FeeItem[];
    onProceed: (fees: FeeItem[]) => void;
};

const PayNow: React.FC<Props> = ({ fees: initialFees, onProceed }) => {
    const [fees, setFees] = useState<FeeItem[]>(
        initialFees.map(f => ({
            ...f,
            amount: f.amount ?? f.due,
        }))
    );

    const handleChange = (index: number, value: string) => {
        const updated = [...fees];

        let num = Number(value);
        if (value === "") num = 0;

        updated[index].amount = num;

        updated[index].invalidError = isNaN(num) || num < 0;
        updated[index].exceedError = num > updated[index].due;

        setFees(updated);
    };

    const blockSpecialChars = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const blocked = ["e", "E", "+", "-", "."];
        if (blocked.includes(e.key)) e.preventDefault();
    };

    const getTotal = () =>
        fees.reduce((sum, f) => sum + (Number(f.amount) || 0), 0);

    const hasAnyError = () =>
        fees.some(f => f.exceedError || f.invalidError);

    return (
        <div style={{ padding: "15px" }}>
            {fees.map((item, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px"
                    }}
                >
                    <div>
                        <div style={{ fontWeight: "bold", color: "#ff9800" }}>
                            {item.feeTitle}
                        </div>

                        <div style={{ fontSize: "13px", color: "#666" }}>
                            Due: ₹{item.due}
                        </div>
                    </div>

                    <div style={{ width: "50%" }}>
                        <input
                            type="number"
                            min={0}
                            value={item.amount}
                            onChange={(e) =>
                                handleChange(index, e.target.value)
                            }
                            onKeyDown={blockSpecialChars}
                            style={{
                                width: "100%",
                                textAlign: "right",
                                padding: "6px",
                                border: "1px solid #ccc",
                                borderRadius: "5px"
                            }}
                        />

                        {item.exceedError && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                                *Amount cannot exceed due
                            </div>
                        )}

                        {item.invalidError && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                                *Invalid amount
                            </div>
                        )}
                    </div>
                </div>
            ))}

            <div style={{ borderTop: "1px solid #ccc", paddingTop: "10px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginBottom: "10px"
                }}>
                    <span>Total Paying</span>
                    <span>₹ {getTotal()}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        disabled={hasAnyError()}
                        onClick={() => onProceed(fees)}
                        style={{
                            backgroundColor: '#4a6572',
                            color: 'white',
                            border: 'none',
                            padding: '8px 20px',
                            borderRadius: '20px',
                            fontWeight: '600',
                            fontSize: '14px'
                        }}>
                        Proceed
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PayNow;